import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import EmployeeWfhSummaryComponent from './EmployeeWfhSummary/EmployeeWfhSummaryComponent';
import EmployeeLeaveSummaryComponent from './EmployeeLeaveSummary/EmployeeLeaveSummaryComponent';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';

function EmployeeSummaryTabComponent() {
  const [activeTab, setActiveTab] = React.useState(0);
  const MasterdataTabs = [
    {
      title: 'WFH Summary',
      index: 0,
      component: <EmployeeWfhSummaryComponent type="wfh" />,
    },
    {
      title: 'Leave Summary',
      index: 1,
      component: <EmployeeLeaveSummaryComponent type="leave" />,
    },
  ];

  return (
    <div>
      <Box className="main-content-overlay">
        <div className="main-content-div">
          <div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={MasterdataTabs}
            />
          </div>
        </div>
      </Box>
    </div>
  );
}

export default EmployeeSummaryTabComponent;
